'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * ui specific actions
 */

module.exports = {

  /**
   */

  showModal: function showModal(modalComponent, options, modalClassName) {
    var div = document.createElement('div');
    div.setAttribute('padding', '15px');

    _reactDom2['default'].render(modalComponent, div);

    var $div = $(div);

    // not very react-like. Works for now
    $div.find('.close').click(function () {
      $.fancybox.close();
    });

    var baseOptions = {
      //'type'            : 'iframe',
      'showCloseButton': true,
      'height': 300,
      'width': 490
    };

    if (options) {
      for (var k in options) {
        baseOptions[k] = options[k];
      }
    }

    baseOptions.onStart = function () {
      $('#fancybox-overlay').addClass('m-fancybox-modal-overlay ' + modalClassName + ' is-hidden');
      $('#fancybox-wrap').addClass('m-fancybox-modal-wrap ' + modalClassName + ' is-hidden');
      $('#fancybox-inner').addClass('m-fancybox-modal-inner ' + modalClassName);
    };

    baseOptions.onComplete = function () {
      $.fancybox.center();
      $('#fancybox-overlay, #fancybox-wrap').removeClass('is-hidden');
      if (options && options.onComplete && typeof options.onComplete === 'function') {
        options.onComplete();
      }
    };

    baseOptions.onClosed = function () {
      $('#fancybox-overlay, #fancybox-wrap, #fancybox-inner').attr('class', '');
      if (options && options.onClosed && typeof options.onClosed === 'function') {
        options.onClosed();
      }
    };

    $div.fancybox(baseOptions).click();
  },

  /**
   */

  alert: function alert(title, text) {}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/actions/ui.js
 ** module id = 419
 ** module chunks = 0
 **/